import React from 'react'
import { CobuStack } from '@cobu/ui'

export default function PublicProfileError() {
  return (
    <CobuStack f={1} ai="center" jc="center" p="$4">
      <CobuStack ai="center" gap="$3">
        <CobuStack w={60} h={60} ai="center" jc="center" br="$full" style={{ backgroundColor: 'var(--backgroundGrey)' }}>
          <CobuStack w={24} h={24} ai="center" jc="center" br="$full" style={{ backgroundColor: 'var(--lightBlueGray)' }} />
        </CobuStack>
        <CobuStack ai="center" gap="$1">
          <CobuStack w={120} h={16} br="$2" style={{ backgroundColor: 'var(--backgroundGrey)' }} />
          <CobuStack w={80} h={12} br="$2" style={{ backgroundColor: 'var(--backgroundGrey)' }} />
        </CobuStack>
      </CobuStack>
    </CobuStack>
  )
}


